const FONT_HEAD = { fontFamily: "'Outfit', sans-serif" };

export const AdminSidebar = ({ section, onSection, onLogout }) => {
  const items = [
    { id: "overview", label: "Overview" },
    { id: "releases", label: "Releases" },
  ];
  return (
    <aside className="hidden md:flex w-64 shrink-0 h-screen sticky top-0 bg-[#0D1322] border-r border-slate-800 flex-col">
      <div className="px-6 py-6 border-b border-slate-800">
        <p style={FONT_HEAD} className="text-lg font-bold text-slate-50 tracking-tight">NINDIYA CONTROL</p>
        <p className="text-xs font-mono text-slate-500 tracking-wider uppercase mt-1">Audio Analytics &amp; CMS</p>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {items.map((item) => (
          <button
            key={item.id}
            data-testid={`admin-nav-${item.id}`}
            onClick={() => onSection(item.id)}
            className={`w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
              section === item.id
                ? "bg-amber-500/10 text-amber-300 border border-amber-500/30"
                : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/60 border border-transparent"
            }`}
          >
            {item.label}
          </button>
        ))}
      </nav>
      <div className="px-3 py-4 border-t border-slate-800">
        <button
          data-testid="admin-logout-button"
          onClick={onLogout}
          className="w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium text-slate-400 hover:text-red-300 hover:bg-red-500/10 transition-colors duration-200"
        >
          Log out
        </button>
      </div>
    </aside>
  );
};
